import { RootStore } from "./RootStore";
import {
  getBoards,
  getBoard,
  deleteBoard,
  createBoard,
  createBoards,
  updateBoard,
  transferBoard,
  getTransferBoard,
  getTransferBoards,
} from "../vendor";
import { Status } from "../vendor/types";

export class BoardStore {
  protected rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  public getBoard = async (id: number) => {
    try {
      return await getBoard(id);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a placa.",
        "error"
      );
      return null;
    }
  };

  public getBoards = async (
    where: {
      onlyNoApply?: boolean;
      textSearch?: string;
      partnerId?: string;
      gameId?: string;
      all?: boolean;
    },
    limit?: number,
    offset?: number
  ) => {
    try {
      return await getBoards(where, limit, offset);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter a lista das placas.",
        "error"
      );
      return null;
    }
  };

  public deleteBoard = async (id: number) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await deleteBoard(id);
      this.rootStore.generalStore.showSnackbar(
        "Placa deletada com sucesso!",
        "success"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return true;
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível deletar essa placa.",
        "error"
      );

      this.rootStore.generalStore.setShowLoading(false);

      return false;
    }
  };

  public createBoard = async (data: {
    serial: string;
    gameId: number;
    depositId: number;
    obs: string;
    boardCreatedDate: Date;
    status: Status;
  }) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const board = await createBoard(data);

      this.rootStore.generalStore.setShowLoading(false);

      return board;
    } catch (err) {
      this.rootStore.generalStore.setShowLoading(false);
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível adquirir essa placa.",
        "error"
      );

      return null;
    }
  };

  public createBoards = async (data: {
    count: number;
    gameId: number | null;
    depositId: number;
    obs: string;
    boardCreatedDate: Date;
    status: Status;
  }) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const boards = await createBoards(data);

      this.rootStore.generalStore.setShowLoading(false);

      return boards;
    } catch (err) {
      this.rootStore.generalStore.setShowLoading(false);
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível adquirir essas placas.",
        "error"
      );

      return null;
    }
  };

  public updateBoard = async (
    data: {
      serial?: string;
      gameId?: number;
      obs?: string;
      boardCreatedDate?: Date;
      status?: Status;
    },
    id: number
  ) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      await updateBoard(data, id);

      this.rootStore.routerStore.push("/dashboard/boards");
      this.rootStore.generalStore.showSnackbar(
        "Placa editada com sucesso!",
        "success"
      );
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível editar essa placa.",
        "error"
      );
    } finally {
      this.rootStore.generalStore.setShowLoading(false);
    }
  };

  public transferBoard = async (data: {
    boardsToTransfer: number[];
    newGameId: number;
    toType: "deposit" | "partner";
    toLocal: number;
    obs: string;
    transferDate: Date;
  }) => {
    this.rootStore.generalStore.setShowLoading(true);

    try {
      const transferBoardPayload = await transferBoard(data);

      this.rootStore.generalStore.setShowLoading(false);

      return transferBoardPayload;
    } catch (err) {
      this.rootStore.generalStore.setShowLoading(false);
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível transferir essa placa.",
        "error"
      );
    }
  };

  public getTransferBoard = async (id: number) => {
    try {
      return await getTransferBoard(id);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message || "Não foi possível obter o log de transferência.",
        "error"
      );
      return null;
    }
  };

  public getTransferBoards = async (
    limit?: number,
    offset?: number,
    where?: {
      textSearch?: string;
      period?: {
        dateInit?: string | null;
        dateEnd?: string | null;
      };
    }
  ) => {
    try {
      return await getTransferBoards(limit, offset, where);
    } catch (err) {
      this.rootStore.generalStore.showSnackbar(
        err.message ||
          "Não foi possível obter a lista de log das transferências.",
        "error"
      );
      return null;
    }
  };
}
